/**
 * Badge de paiement d'une commande, ou null quand il n'y a rien a signaler.
 *
 * Codes StatuPaiement cote API : 4 = paiement carte refuse (webhook
 * payment_failed), 5 = paiement annule ou expire avant la date limite.
 *
 * Le 2 veut dire « en attente de paiement » seulement pour un client hors
 * compte : pour un client en compte ou un partenaire (source 3, facture au
 * mois), il veut dire « non facture », ce qui est normal. Meme regle que le
 * scope paiementAcquisOuNonRequis de l'API, qui sort ces commandes du dashboard.
 *
 * StatuPaiement n'est pas caste cote API : Number() evite de dependre du pilote.
 */
export const badgePaiement = (commande) => {
  const statut = Number(commande?.StatuPaiement);

  if (statut === 4) {
    return { bg: 'danger', label: 'Paiement échoué' };
  }
  if (statut === 5) {
    return { bg: 'danger', label: 'Paiement annulé' };
  }
  if (
    statut === 2 &&
    Number(commande?.source) !== 3 &&
    commande?.fournisseur_profil?.paiement_en_compte === false
  ) {
    return { bg: 'warning', text: 'dark', label: 'Paiement en attente' };
  }
  return null;
};
